export const locales = ["ru", "en", "ky"] as const;
export type Locale = (typeof locales)[number];

export const localeCookieName = "amazona_locale";

export function isLocale(value: string | undefined | null): value is Locale {
  const t = typeof value === "string" ? value.trim() : "";
  return !!t && (locales as readonly string[]).includes(t);
}

/** Normalized locale from a cookie/header fragment, or null. */
export function parseLocale(value: string | undefined | null): Locale | null {
  let t = typeof value === "string" ? value.trim() : "";
  if (!t) return null;
  if (t.includes("%")) {
    try {
      t = decodeURIComponent(t);
    } catch {
      return null;
    }
  }
  return isLocale(t) ? t : null;
}

export function detectLocaleFromAcceptLanguage(
  headerValue: string | null | undefined,
): Locale {
  if (!headerValue) return "ru";
  // Example: "en-US,en;q=0.9,ru;q=0.8"
  const parts = headerValue
    .split(",")
    .map((p) => p.trim().toLowerCase())
    .filter(Boolean);

  for (const part of parts) {
    const tag = part.split(";")[0]?.trim();
    if (!tag) continue;
    const primary = tag.split("-")[0];
    if (primary === "kg") return "ky";
    if (isLocale(primary)) return primary;
  }
  return "ru";
}

